/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext, useEffect, useState } from "react";
import { ContentZoneContext } from "cms/components/context";
import { RichTextPreview } from "cms/rich-text/simplicity-composer-tiptap/index";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import { ButtonCTALinkButton } from "./link-button";
import "styles/components/button-cta.css";

const ButtonCTAComponentDisplay = () => {
    const { token } = useAuth();
    const { component } = useContext(ContentZoneContext);
    const title = component.title;
    const subtitle = component.subtitle;
    const description = component.description;
    const links_guids = component.links || [];
    const linkProperties = component.linkProperties || {};

    const [links, setLinks] = useState([]);
    const [loadingLinks, setLoadingLinks] = useState(false);

    // onClickLink is now handled in the ButtonCTALinkButton component

    useEffect(() => {
        const getLinks = async () => {
            if (links_guids.length === 0) return;
            
            try {
                setLoadingLinks(true);
                const loadedLinks = await Promise.all(
                    links_guids.map(linkGuid => 
                        SimpliCityAdminSDK.link.findOne(token, linkGuid)
                    )
                );
                setLinks(loadedLinks);
            } catch (error) {
                console.error('Error loading links:', error);
            } finally {
                setLoadingLinks(false);
            }
        };
        getLinks();
    }, [links_guids, token]);

    return (
        <div className="button-cta-container">
            <div className="button-cta-content">
                <div className="button-cta-title">
                    <h2 className="button-cta-title-main">{title}</h2>
                    <h2 className="button-cta-title-subtitle">{subtitle}</h2>
                </div>
                <div className="button-cta-description">
                    <RichTextPreview richtext={description} />
                </div>
                <div className="button-cta-links">
                    {loadingLinks ? (
                        <div className="button-cta-loading">Loading...</div>
                    ) : (
                        links.map((link, index) => (
                            <ButtonCTALinkButton 
                                key={index}
                                link={link}
                                linkProperties={linkProperties}
                            />
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

ButtonCTAComponentDisplay.displayName = "ButtonCTAComponentDisplay";
export { ButtonCTAComponentDisplay };